import { MAX_FILE_SIZE, MAX_FILE_SIZE_ERROR } from "./files";

export const buildFormDataPayload = <
  T extends Record<string, unknown>,
  K extends keyof T
>(
  payload: T,
  fileKeys: K[]
): FormData => {
  // Extract specified keys
  const files = {} as Record<string, File>;
  const data = {} as Record<string, unknown>;
  const formData = new FormData();

  Object.keys(payload).forEach((key) => {
    if (fileKeys.includes(key as K)) {
      files[key] = payload[key] as File;
    } else {
      data[key] = payload[key];
    }
  });

  formData.append("data", JSON.stringify(data));

  for (const key in files) {
    if (files[key]?.size > MAX_FILE_SIZE) {
      throw new Error(`${key}: ${MAX_FILE_SIZE_ERROR}`);
    } else {
      formData.append(key, files[key]);
    }
  }

  return formData;
};
